export default "__VITE_ASSET__5b9606b1__"